import { Component } from '@angular/core';
import { PAGE_SIZE, MAX_SIZE } from 'src/app/onelog/common/config/common';
import { RequestService } from 'src/app/onelog/services/request.service';
import { DEV_FD_PENDING_ACCEPTANCE_URL } from 'src/app/onelog/common/config/url';
import { SELECT_TYPE_DROP_DOWN_OPTIONS_EQUAL_NOT_EQUAL } from 'src/app/onelog/common/config/dropdown-config';

@Component({
  selector: 'app-dev-fd-pending-acceptance',
  templateUrl: './dev-fd-pending-acceptance.component.html',
  styleUrls: ['./dev-fd-pending-acceptance.component.css'],
})
export class DevFdPendingAcceptanceComponent {
  pageSize: number = PAGE_SIZE;
  maxSize: number = MAX_SIZE;
  products: any = [];
  totalProducts: number = 0;
  perPage: number = 10;
  lastPage: number = 0;
  currentPage: number = 0;
  selectStatusTypeDropDownOptions: any =
    SELECT_TYPE_DROP_DOWN_OPTIONS_EQUAL_NOT_EQUAL;
  selectedUserId: string = '';
  userIdFilterData: any = [];

  constructor(private requestService: RequestService) {}

  ngOnInit() {
    this.getData();
  }

  getData(
    url: string = DEV_FD_PENDING_ACCEPTANCE_URL,
    data: any = [],
    urlParams: string = ''
  ) {
    this.requestService
      .postRequest(url, data, urlParams)
      .subscribe((data: any) => {
        console.log(data);
        this.products = data.data;
        this.totalProducts = data.total;
        this.perPage = data.per_page;
        this.lastPage = data.last_page;
        this.currentPage = data.current_page;
      });
  }

  updateSelectedType(event: any) {
    let eventData = event;
    if (eventData.name == 'userId') {
      this.userIdFilterData['filterType'] = eventData.selectedOption;
    }
    console.log(event);
  }
  downloadReport() {
    this.requestService.download(
      DEV_FD_PENDING_ACCEPTANCE_URL,
      this.createPostData(),
      '/?is_download=1',
      `DEV_FD_PENDING_ACCEPTANCE${new Date().toLocaleString()}.xlsx`
    );
  }

  searchProduct() {
    this.getData(DEV_FD_PENDING_ACCEPTANCE_URL, this.createPostData());
  }

  createPostData() {
    this.setFilterData();

    return {
      userIdFilterData: Object.assign({}, this.userIdFilterData),
    };
  }

  setFilterData() {
    this.userIdFilterData['value'] = this.selectedUserId;
  }

  updatePageData(event: Event) {
    let eventData: any = event;
    let urlParams = '?page=' + eventData.currentPage;
    this.currentPage = eventData.currentPage;
    this.getData(
      DEV_FD_PENDING_ACCEPTANCE_URL,
      this.createPostData(),
      urlParams
    );
  }
}
